export default {
    countryDivisionID: null,
    name: '',
    parenthierarchyID: null,
    code: ''
}